import {
    ROOM_SWITCHED,
    ROOM_DESTROYED,
    ROOM_UPDATED,
    ROOM_INACTIVE,
    ROOM_TYPE_PERSONAL
} from '../constants/rooms';

import {LOGIN_SUCCESS} from '../constants/general';
import Registry from '../registry';

const defaultState = {
    id: '',
    type: undefined,
    exists: false
};

export default function currentRoom(state = defaultState, action) {
    if (action.type === LOGIN_SUCCESS) {

        return {
            id: action.room.roomid,
            options: action.room.roomoptions || {},
            name: action.room.name || "",
            type: action.room.type,
            creator: action.room.creator,
            server_id: Registry.get('chatInterface').getServerId(),
            showroom_price: action.room.showroom_price ? action.room.showroom_price : 0,
            exists: true
        };
    }

    if (action.type === ROOM_UPDATED) {
        if (action.room.roomid == state.id) {
            return {
                id: action.room.roomid,
                options: action.room.roomoptions || {},
                name: action.room.name || "",
                type: action.room.type,
                creator: action.room.creator,
                server_id: Registry.get('chatInterface').getServerId(),
                showroom_price: action.room.showroom_price ? action.room.showroom_price : 0,
                exists: true
            };
        }
    }

    if (action.type === ROOM_INACTIVE) {
        return {
            id: '',
            name: '',
            type: ROOM_TYPE_PERSONAL,
            exists: false
        }
    }

    if (action.type === ROOM_SWITCHED) {
        return {
            id: action.name,
            exists: true
        };
    }

    if (action.type === ROOM_DESTROYED) {
        if (state.type === ROOM_TYPE_PERSONAL) {
            return {
                ...state,
                exists: false
            }
        }
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/currentRoom.js